module.exports = __webpack_public_path__ + "static/loader_mobile-77955bd003664a1b5aac74df20a8956f.mp4";